import { Presets, presets } from '../form/datepicker/datetime'
import { sspDate } from './sspDate'

export const to = { to: sspDate(presets[Presets.last30days].end()) }
